const initialState = {
    publishingChallenge: false,
    showPublishChallengeStatusModal: false,
    validationErrors: null,
    validatingChallenge: false,
    showValidateChallengeStatusModal: false,
    successful: null
};

export default initialState;



// WEBPACK FOOTER //
// ./public/pages/BreakPublish/initialState.js